// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__uC0fH","container":"hero_container__9ry93","image":"hero_image__ysoj2","button":"hero_button__0mpiy"};